import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {TestArea} from 'src/app/common/test-area';
import {ApiService} from 'src/app/services/api.service';
import {ErrorHelper} from '../../common/ErrorHelper';
import {NotifierService} from 'angular-notifier';
import {User} from '../../model/user';
import {AppComponent} from '../../app.component';

export interface DynamicImageSetToVersion {
  disId: string;
  versionId: string;
  versionLabel: string;
  redirectInfo: RedirectInfo;
}

export interface RedirectInfo {
  extLayerSourceDisId: string;
  extRulesSourceDisId: string;
  intLayerSourceDisId: string;
  intRulesSourceDisId: string;
}

@Component({
  selector: 'app-layer-set-mapping',
  templateUrl: './layer-set-mapping.component.html',
  styleUrls: ['./layer-set-mapping.component.css']
})
export class LayerSetMappingComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['disId', 'redirect', 'versionId', 'versionLabel'];
  dataSource: MatTableDataSource<DynamicImageSetToVersion>;
  filterValues = {
    dis: '',
    version: '',
  };

  disFilter = new FormControl();
  versionFilter = new FormControl();

  @ViewChild(MatSort) sort: MatSort;

  testArea = TestArea;
  selectedClass = 'embargo';
  selectedTestArea = TestArea.EMBARGO;
  user = new User();

  constructor(
    private apiService: ApiService,
    public notifierService: NotifierService,
    private app: AppComponent,
  ) {
    this.dataSource = new MatTableDataSource<DynamicImageSetToVersion>();
  }

  ngOnInit(): void {
    this.app.getUserData().then(user => {
      this.user = user;
      if (user.hasEmbargoPermissions()) {
        this.selectedClass = 'embargo';
        this.selectedTestArea = TestArea.EMBARGO;
      } else {
        this.selectedClass = 'preprod';
        this.selectedTestArea = TestArea.PREPROD;
      }
      this.loadDataAsync();
    });
  }

  ngAfterViewInit(): void {
    this.disFilter.valueChanges
      .subscribe(dis => {
        this.filterValues.dis = dis;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      });
    this.versionFilter.valueChanges
      .subscribe(
        version => {
          this.filterValues.version = version;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
  }

  selectTestArea(test: TestArea): void {
    this.selectedTestArea = test;
    this.selectedClass = this.selectedTestArea.toLowerCase().split(' ').find(e => true);
    this.loadDataAsync();
    this.reset();
    this.dataSource = new MatTableDataSource();
  }

  async loadDataAsync(): Promise<any> {
    try {
      await this.loadData();
    } catch (error) {
      console.log(error);
    } finally {
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = (data: DynamicImageSetToVersion, filter) => {
        const searchTerms = JSON.parse(filter);
        const disFilter = data.disId.toLowerCase().includes(searchTerms.dis.toLowerCase());
        const versionFilter = data.versionId.toLowerCase().includes(searchTerms.version.toLowerCase());
        return disFilter && versionFilter;
      };
    }
  }

  loadData(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.apiService.getLcdvMapping(this.selectedTestArea).toPromise().then(
        (data) => {
          const dynamicImageSetsToVersion = data;
          this.dataSource = new MatTableDataSource<DynamicImageSetToVersion>(dynamicImageSetsToVersion);
          console.log('Fetched the dynamic image set to version mapping');
          resolve(true);
        },
        (error) => {
          const errorMessage = ErrorHelper.disectError('load mapping', error);
          this.notifierService.notify('error', errorMessage);
          resolve(false);
        });
    });
  }

  reset(): void {
    this.disFilter = new FormControl();
    this.versionFilter = new FormControl();

    this.filterValues.dis = '';
    this.filterValues.version = '';
    this.dataSource.filter = JSON.stringify(this.filterValues);
  }

}
